export default __webpack_public_path__ + "static/media/scientific-articles-bg.3f83343c.svg";